'use client'
import dynamic from 'next/dynamic'
import type { PointTuple } from 'leaflet';

import useIsMobile from '@/hooks/useMobile';
import { MapAgency } from "./mapAgency";

const MapResult = dynamic(() => import("./Map").then((mod) => mod.Map), {
  ssr: false,
  loading: () => (
    <div
      style={{ 
        height: '400px', 
        width: '100%', 
        background: '#f0f0f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      Chargement de la carte...
    </div>
  ),
});

export type AgenciesMapProps = {
  agencies: MapAgency[],
  className?: string,
  /** Marge (px) haut/gauche lors du recadrage sur les agences, ex. pour un panneau superposé */
  paddingTopLeft?: PointTuple,
  /** Ne rend (et ne charge) la carte qu'en desktop */
  desktopOnly?: boolean
}

export const AgenciesMap = ({desktopOnly, ...props}: AgenciesMapProps) => {
  const { isMobile, isLoading } = useIsMobile()

  // le chunk Leaflet n'est chargé qu'au premier rendu de MapResult :
  // ne rien rendre en mobile évite de le télécharger
  if (desktopOnly && (isLoading || isMobile)) return null

  return <MapResult {...props}/>;
}
